// darkModeToggle.js

export function initializeDarkModeToggle(buttonId, darkModeClass) {
    const toggleButton = document.getElementById(buttonId);
    const bodyElement = document.body;

    // Check if the user has a saved preference
    let currentMode = localStorage.getItem('dark-mode');

    // If no preference is saved, use the system preference
    if (currentMode === null) {
        currentMode = window.matchMedia('(prefers-color-scheme: dark)').matches ? 'enabled' : 'disabled';
    }

    if (currentMode === 'enabled') {
        bodyElement.classList.add(darkModeClass);
        toggleButton.setAttribute('aria-pressed', 'true');
    }

    toggleButton.addEventListener('click', function () {
        const isDarkMode = bodyElement.classList.toggle(darkModeClass);
        
        // Update aria-pressed attribute
        if (isDarkMode) {
            toggleButton.setAttribute('aria-pressed', 'true');
            localStorage.setItem('dark-mode', 'enabled');
        } else {
            toggleButton.setAttribute('aria-pressed', 'false');
            localStorage.setItem('dark-mode', 'disabled');
        }
    });
}
